import { DICTIONARY } from './i18n-dict'

/**
 * Paprastas i18n: raktas = LIETUVIŠKA eilutė (jos versti nereikia, o neišverstos
 * eilutės tiesiog lieka lietuviškos — dalinis vertimas nelaužo nieko).
 *
 * Vertimai — src/lib/i18n-dict.ts (LT → { ru, en }). Interpoliacija per {vardas}:
 *   t('Patvirtinti visas ({n})', { n: 5 })
 */
export type Locale = 'lt' | 'ru' | 'en'
export const LOCALES: Locale[] = ['lt', 'ru', 'en']
export const LOCALE_LABEL: Record<Locale, string> = { lt: 'Lietuvių', ru: 'Русский', en: 'English' }
export const LOCALE_SHORT: Record<Locale, string> = { lt: 'LT', ru: 'RU', en: 'EN' }

export function translate(
  locale: Locale,
  lt: string,
  vars?: Record<string, string | number>,
): string {
  let s = locale === 'lt' ? lt : DICTIONARY[lt]?.[locale] ?? lt
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.split(`{${k}}`).join(String(v))
    }
  }
  return s
}

export function isLocale(v: string | undefined | null): v is Locale {
  return v === 'lt' || v === 'ru' || v === 'en'
}
